import { render, staticRenderFns } from "./CoursesDropdown.vue?vue&type=template&id=657818f4&scoped=true&"
import script from "./CoursesDropdown.vue?vue&type=script&lang=ts&"
export * from "./CoursesDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesDropdown.vue?vue&type=style&index=0&id=657818f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657818f4",
  null
  
)

export default component.exports